module.exports = __webpack_public_path__ + "img/ICONO7.f92bea1d.png";